import { StandardProductListItem } from '@/General/ProductListing/StandardProductList/StandardProductListItem'
import type { SaleProductRow } from './saleProducts'

export const SaleProductRows = ({ products }: SaleProductRowsProps) => {
  return (
    <>
      {products.map(product => (
        <StandardProductListItem
          key={product.id}
          {...product}
          primaryAction="add-to-cart"
        />
      ))}
    </>
  )
}

type SaleProductRowsProps = {
  products: SaleProductRow[]
}
